import { Component, Inject, OnInit, ViewEncapsulation } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { RecordAction } from "../../../../../utils/enums/shared/enums";
import { MiembroCsvDTO } from "../../../../../utils/types/groups/miembroCsvDTO.type";
import { Delimiter } from "../../../../../utils/types/shared/delimiter";
import { SharedCatalogService } from "../../../../../services/shared/sharedcatalog.service";
import { MiembrosService } from "../../../../../services/groups/miembros.service";
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: "wtf-miembro-form-csv",
    templateUrl: "./miembro-form-csv.component.html",
    styleUrls: ["./miembro-form-csv.component.scss"],
    encapsulation: ViewEncapsulation.None,
    providers: [SharedCatalogService, MiembrosService],
})
export class MiembroFormCSVComponent implements OnInit {
    miembroCsvModel: MiembroCsvDTO;
    dialogTitle: string;
    miembroCsvForm: FormGroup;
    action: RecordAction;
    fileToUpload: any;
    fileDescription: FormControl;
    shortCodes: any;

    callback: (miembro) => void;

    operators: any;
    groups: any;
    widget6: any = {};
    results: any;
    view: any[] = [450, 200];
    // presetColors = MatColors.presets;
    recordAction = RecordAction;

    delimiters: Delimiter[];
    public modalSize: string = "sm";

    processing = false;
    finished = false;

    constructor(
        public dialogRef: MatDialogRef<MiembroFormCSVComponent>,
        @Inject(MAT_DIALOG_DATA) private data: any,
        private sharedCatalog: SharedCatalogService,
        private miembroService: MiembrosService,
        private translateService: TranslateService
    ) {
        this.action = data.action;
        this.operators = data.operators;
        this.groups = data.groups;
        console.log(this.groups);

        this.callback = data.callback;

        this.dialogTitle = "Agregar Miembros por CSV";
        this.dialogTitle = this.translateService.instant(this.dialogTitle);
        this.miembroCsvModel = new MiembroCsvDTO();
        this.delimiters = sharedCatalog.getDelimiters();

        this.miembroCsvForm = this.createForm();

        this.widget6 = {
            label: "Registros Procesados",
            scheme: {
                domain: ["#03a9f4", "#f44336", "#db951c", "#9c27b0"],
            },
        };

        this.widget6.label = this.translateService.instant(this.widget6.label);
    }

    ngOnInit() {}

    createForm() {
        const form = new FormGroup({
            fileInput: new FormControl("", [Validators.required]),
            //    isActive: new FormControl( Boolean(this.miembroModel.status)),
            //    operadora: new FormControl(this.miembroModel.operatorId, [Validators.required])
        });

        //   form.controls['isActive'].valueChanges.subscribe((value) => this.miembroModel.status = Number(value));
        //   form.controls['operadora'].valueChanges.subscribe((value) => this.miembroModel.operatorId = value);

        return form;
    }

    performAction() {
        if (this.miembroCsvForm.invalid) {
            return;
        }

        this.processing = true;
        this.miembroCsvModel.file = this.fileToUpload;
        this.miembroCsvModel.groups = this.groups;

        this.performAddMiembroCsv(this.miembroCsvModel);
    }

    handleFileInput(files: FileList) {
        const file = document.querySelector("#file");

        const fileItem = files.item(0);
        this.fileToUpload = fileItem;
        this.miembroCsvForm.controls["fileInput"].setValue(
            fileItem ? fileItem.name : ""
        );

        document.querySelector(".file-name").textContent = fileItem.name;
    }

    performAddMiembroCsv(data: MiembroCsvDTO) {
        this.miembroService.processCSV(data).subscribe((res) => {
            if (res) {
                this.miembroService.uploadCSV(res).subscribe((result) => {
                    // this.results = [
                    //     {
                    //         name: "Exitosos",
                    //         value: result.success,
                    //     },
                    //     {
                    //         name: "Con Error",
                    //         value: result.errorFormat,
                    //     },
                    //     {
                    //         name: "Duplicados",
                    //         value: result.duplicated,
                    //     },
                    // ];

                    // this.results.forEach((element) => {
                    //     element.name = this.translateService.instant(
                    //         element.name
                    //     );
                    // });

                    this.processing = false;
                    this.finished = true;
                    this.modalSize = "md";
                });
            }
        });
    }

    close() {
        this.callback(this.miembroCsvModel);
    }
}
